import React from "react";

const CurvedRightArrow = ({
  className = "w-5 h-5",
  fill = "white",
}: {
  className: string;
  fill: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 20"
      fill="none"
      className={className}
    >
      <path
        d="M13.5775 5.16505L5.03581 14.8357M13.5775 5.16505L13.7776 13.4118M13.5775 5.16505L5.90343 5.38008"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CurvedRightArrow;
